import { render, staticRenderFns } from "./DateProductManufacturerModal.vue?vue&type=template&id=784ca327&scoped=true&"
import script from "./DateProductManufacturerModal.vue?vue&type=script&lang=js&"
export * from "./DateProductManufacturerModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "784ca327",
  null
  
)

export default component.exports